import { render, staticRenderFns } from "./signDetail.vue?vue&type=template&id=53b58e55&scoped=true"
import script from "./signDetail.vue?vue&type=script&lang=js"
export * from "./signDetail.vue?vue&type=script&lang=js"
import style0 from "./signDetail.vue?vue&type=style&index=0&id=53b58e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b58e55",
  null
  
)

export default component.exports